import React from 'react';
import { FDIcon } from '@facet-wealth/design';

// This file is what allows us to use DS components inside of hte d3 chart.
// The way it works is that we render these invisible icons which show up on the DOM as SVG elements, then since SVG
// are valid within other SVGs I just copy the nodes into the D3 chart as needed.
export const VisualizationIcons = () => {
  return (
    <div style={{ display: 'none' }}>
      <FDIcon icon={'outcomeSavings'} data-icon={'outcomeSavings'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeSavings'} data-icon={'savings'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeRetirement'} data-icon={'outcomeRetirement'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeDebt'} data-icon={'outcomeDebt'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeProperty'} data-icon={'outcomeProperty'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeEmergencyFund'} data-icon={'outcomeEmergencyFund'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'outcomeEducation'} data-icon={'outcomeEducation'} data-semantic={'visualization-icon'} />
      <FDIcon icon={'fac'} data-icon={'fac'} data-semantic={'result-icon'} />
    </div>
  );
};
